import { Component, OnInit } from '@angular/core';
import { faClipboard } from '@fortawesome/free-regular-svg-icons';

@Component({
  selector: '[empty-table-state]',
  templateUrl: './empty-table-state.component.html',
  styleUrls: ['./empty-table-state.component.scss']
})
export class EmptyTableStateComponent implements OnInit {
  faClipboard = faClipboard;
  constructor() {}

  ngOnInit(): void {}
}
